import { IRCTC_HERO_IMG, IRCTC_FOOTER_IMG, IRCTC_LOGO } from "@swiggy-private/generic-mxn-ui/dist/irctcPnrSearchFlow";
import {
    VOUCHER_MASH_HEAD_IMG,
    VOUCHER_EXPIRED_BANNER_IMG,
    VOUCHER_FOOTER_IMG,
} from "@swiggy-private/generic-mxn-ui/dist/VoucherPage";

export const IOS_APP_USER_AGENT = "swiggy-ios";
export const ANDROID_APP_USER_AGENT = "swiggy-android";

export const SOURCES = {
    ORGANIC: "organic",
    INORGANIC: "inorganic",
};

export const IRCTC_TNC_URL = "https://webviews.swiggy.com/portal-static-page/irctc_tnc";

export const WEB_VIEW_URL = "swiggy://webview?webview_url={0}";

const BASE_ADDRESS = process.env.NEXT_PUBLIC_BASE_ADDRESS || "http://localhost:3000/portal-static-page";

export const FORMATTED_BASE_ADDRESS = BASE_ADDRESS + "/communities_tnc";

export const COMMUNITIES_TNC_DEEPLINK = `swiggy://externalWidget?banner_type=WEBVIEW&card_type=HALF_CARD&ratio=1.8&url={0}`;

export const SCENES_REDIRECTION_URL = "scenes_redirection_url";

export const PRELOAD_IMAGES = [IRCTC_HERO_IMG, IRCTC_FOOTER_IMG, IRCTC_LOGO];

export const PRELOAD_VOUCHER_IMAGES = [VOUCHER_MASH_HEAD_IMG, VOUCHER_EXPIRED_BANNER_IMG, VOUCHER_FOOTER_IMG];

export const NEW_RELIC_APPLICATION_ID = process.env.NEXT_PUBLIC_NEW_RELIC_APP_ID || "";

export const X_CHANNEL_IM_SHELL = "IM-Shell";
